import { Component } from '@angular/core';

import { RealtimeToast, RealtimeToastItem } from '../../core/services/realtime-toast';

@Component({
  selector: 'app-realtime-toasts',
  standalone: false,
  templateUrl: './realtime-toasts.html',
  styleUrl: './realtime-toasts.scss',
})
export class RealtimeToasts {
  constructor(readonly realtimeToasts: RealtimeToast) {}

  open(toast: RealtimeToastItem): void {
    void this.realtimeToasts.open(toast);
  }

  dismiss(toast: RealtimeToastItem, event: Event): void {
    event.stopPropagation();
    this.realtimeToasts.dismiss(toast.id);
  }

  iconLabel(toast: RealtimeToastItem): string {
    if (toast.kind === 'email') return 'Email';
    if (toast.kind === 'chat') return 'Chat';
    return 'Notification';
  }

}
